import { render, staticRenderFns } from "./fotosAdicionais.vue?vue&type=template&id=b4baa25a&"
import script from "./fotosAdicionais.vue?vue&type=script&lang=js&"
export * from "./fotosAdicionais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports